// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --default-main-color: #2665f6;
  --default-main-lighten-color: rgba(38, 101, 246, 0.45);
  --default-second-color: #36C9E4;

  --default-home-widget-1-color: #01319F;
  --default-home-widget-2-color: #2665f6;
  --default-home-widget-3-color: #36C9E4;
  --default-home-widget-4-color: #B0B9DE;
  --default-mobile-header-color: #01319F;


  --main-color: var(--default-main-color);
  --main-lighten-color: var(--default-main-lighten-color);
  --second-color: var(--default-second-color);

  --home-widget-1-color: var(--default-home-widget-1-color);
  --home-widget-2-color: var(--default-home-widget-2-color);
  --home-widget-3-color: var(--default-home-widget-3-color);
  --home-widget-4-color: var(--default-home-widget-4-color);
}
`, "",{"version":3,"sources":["webpack://./src/scss/colors.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,sDAAsD;EACtD,+BAA+B;;EAE/B,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;;;EAGtC,uCAAuC;EACvC,uDAAuD;EACvD,2CAA2C;;EAE3C,yDAAyD;EACzD,yDAAyD;EACzD,yDAAyD;EACzD,yDAAyD;AAC3D","sourcesContent":[":root {\n  --default-main-color: #2665f6;\n  --default-main-lighten-color: rgba(38, 101, 246, 0.45);\n  --default-second-color: #36C9E4;\n\n  --default-home-widget-1-color: #01319F;\n  --default-home-widget-2-color: #2665f6;\n  --default-home-widget-3-color: #36C9E4;\n  --default-home-widget-4-color: #B0B9DE;\n  --default-mobile-header-color: #01319F;\n\n\n  --main-color: var(--default-main-color);\n  --main-lighten-color: var(--default-main-lighten-color);\n  --second-color: var(--default-second-color);\n\n  --home-widget-1-color: var(--default-home-widget-1-color);\n  --home-widget-2-color: var(--default-home-widget-2-color);\n  --home-widget-3-color: var(--default-home-widget-3-color);\n  --home-widget-4-color: var(--default-home-widget-4-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
